import type {
  KnowledgeProvider,
  KnowledgeQuery,
  KnowledgeResult,
  ProviderCapabilities,
  ProviderHealth,
} from '../core/contracts/index.js';

export class MockRagProvider implements KnowledgeProvider {
  public id = 'mock-rag-provider';
  public version = '1.0.0';
  public capabilities: ProviderCapabilities = {
    knowledgeModes: ['rag', 'direct'],
    streaming: false,
    cancellation: true,
    humanApproval: false,
    citations: true,
    externalActions: false,
  };

  async query(request: KnowledgeQuery): Promise<KnowledgeResult> {
    const queryLower = request.query.toLowerCase();

    return {
      modeUsed: 'rag',
      content: `[RAG Evidence for Tenant ${request.scope.tenantId}]: Verified source material matching query "${request.query}".`,
      citations: [
        {
          sourceId: 'doc-faq-101',
          title: 'Tenant FAQ & Operating Guidelines',
          snippet: `Passage excerpt matching "${queryLower}" in room ${request.scope.roomId || 'global'}.`,
          score: 0.94,
          version: '1.2.0',
        },
      ],
      queryTimeMs: 12,
    };
  }

  async health(): Promise<ProviderHealth> {
    return {
      status: 'healthy',
      providerId: this.id,
      version: this.version,
      lastCheckedAt: Date.now(),
    };
  }
}
